// System
import { useDispatch } from 'react-redux';
import { Button, Select, Stack, Typography } from '@mui/material';
import { AtLocator } from '@Components/shared/locators/AtLocator';
// Redux
import { useRoundsTable } from '@Modal/hooks/rounds/useRoundsTable';
import { useAuthorization } from '@Modal/hooks/authorization/useAuthorization';
// Graphql
import // useAviatorLiveRoundStatusQuery,
// useGetAviatorRoundConfigsQuery,
'@Src/generated.graphql';
import { useEffect, useMemo } from 'react';
import { MenuItemEx } from '@Components/shared/selects/MenuItemEx';

export const RoundsTitle: React.FC = () => {
  const dispatch = useDispatch();
  const {
    // roundTableFilters,
    clearRoundTableFiltersHandler,
    setShowRoundStatusModalDialog,
    // currentRoundConfig,
    handleSetCurrentRoundConfig,
  } = useRoundsTable();

  const { currentUser } = useAuthorization();
  // const { data: aviatorRoundConfigsData } = useGetAviatorRoundConfigsQuery();
  // const { data: aviatorLiveRoundStatus } = useAviatorLiveRoundStatusQuery({
  //   variables: { configId: currentRoundConfig?.id },
  // });

  // const objectVals = Object.values(roundTableFilters);
  // const disabled = objectVals.length === 0 || objectVals.every((val) => val === undefined);
  //
  // useEffect(() => {
  //   if (aviatorRoundConfigsData) {
  //     handleSetCurrentRoundConfig(aviatorRoundConfigsData.aviatorRoundConfigs[0]);
  //   }
  // }, [aviatorRoundConfigsData]);

  // const gameVersionDropdown = useMemo(
  //   () =>
  //     aviatorRoundConfigsData?.aviatorRoundConfigs?.map((roundConfig) => (
  //       <MenuItemEx
  //         key={roundConfig.id}
  //         value={roundConfig.id}
  //         name="Game Versions"
  //         onClick={() => roundConfig.id && handleSetCurrentRoundConfig(roundConfig)}
  //       >
  //         {roundConfig.description}
  //       </MenuItemEx>
  //     )),
  //   [aviatorRoundConfigsData]
  // );

  return (
    <AtLocator type="container" name="roundsListTitle">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ paddingBottom: 2 }}
      >
        <Typography variant="h3">Rounds</Typography>
        <Stack direction="row" alignItems="center" gap={2}>
          {/* {currentUser?.isSuper && (
            <Stack direction="row" gap={1}>
              {aviatorRoundConfigsData?.aviatorRoundConfigs?.length && (
                <Select
                  sx={{ height: '48px', minWidth: '200px' }}
                  defaultValue={aviatorRoundConfigsData.aviatorRoundConfigs[0].id}
                >
                  {gameVersionDropdown}
                </Select>
              )}
              <AtLocator type="button" name="clearFilters">
                <Button
                  size="large"
                  variant="contained"
                  onClick={() => dispatch(setShowRoundStatusModalDialog(true))}
                >
                  {currentRoundConfig?.description} status:{' '}
                  {aviatorLiveRoundStatus?.aviatorLiveRoundStatus}
                </Button>
              </AtLocator>
            </Stack>
          )} */}
          <AtLocator type="button" name="clearFilters">
            <Button
              size="large"
              variant="contained"
              // disabled={disabled}
              onClick={clearRoundTableFiltersHandler}
            >
              Clear filters
            </Button>
          </AtLocator>
        </Stack>
      </Stack>
    </AtLocator>
  );
};
